<template>
  <div class="authenticated-shell">
  <LoginDevicesBanner />
  <main class="app-shell" :class="{ 'h5-detail-open': h5DetailOpen }">
    <NavigationRail />
    <ConversationList v-if="navigation.section === 'messages'" @detail-open="openH5Detail" />
    <FavoriteList v-else-if="navigation.section === 'favorites'" @detail-open="openH5Detail" />
    <ContactList v-else @detail-open="openH5Detail" />
    <ChatPanel v-if="navigation.section === 'messages'" />
    <FavoritePanel v-else-if="navigation.section === 'favorites'" />
    <ContactPanel v-else />
    <button
      v-if="isH5Compact && h5DetailOpen"
      type="button"
      class="h5-detail-back"
      :title="language.t('conversationTools.back')"
      :aria-label="language.t('conversationTools.back')"
      @click="closeH5Detail"
    >‹</button>
  </main>
  </div>
</template>

<script setup>
import LoginDevicesBanner from './LoginDevicesBanner.vue';
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import NavigationRail from './sidebar/NavigationRail.vue';
import ConversationList from './sidebar/ConversationList.vue';
import ContactList from './sidebar/ContactList.vue';
import ChatPanel from './chat/ChatPanel.vue';
import ContactPanel from './contacts/ContactPanel.vue';
import FavoriteList from './favorites/FavoriteList.vue';
import FavoritePanel from './favorites/FavoritePanel.vue';
import { useConversationStore } from '@/stores/conversations';
import { useNavigationStore } from '@/stores/navigation';
import { useContactStore } from '@/stores/contacts';
import { useLanguageStore } from '@/stores/language';

const conversations = useConversationStore();
const navigation = useNavigationStore();
const contacts = useContactStore();
const language = useLanguageStore();
const h5DetailOpen = ref(false);
const isH5Compact = ref(false);
let friendApplicationTimer = 0;

function updateH5Layout() {
  isH5Compact.value = window.matchMedia('(max-width: 760px)').matches;
  if (!isH5Compact.value) {
    h5DetailOpen.value = false;
  }
}

function openH5Detail() {
  if (isH5Compact.value) {
    h5DetailOpen.value = true;
  }
}

function closeH5Detail() {
  h5DetailOpen.value = false;
}

onMounted(() => {
  updateH5Layout();
  window.addEventListener('resize', updateH5Layout);
  conversations.refreshRemoteConversations();
  contacts.refreshContacts();
  contacts.refreshFriendApplications();
  friendApplicationTimer = window.setInterval(() => {
    contacts.refreshFriendApplications({ force: true, silent: true });
  }, 5000);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateH5Layout);
  window.clearInterval(friendApplicationTimer);
});

watch(() => navigation.section, closeH5Detail);
</script>

<style>
.authenticated-shell{height:100%;display:flex;flex-direction:column;overflow:hidden}.authenticated-shell>.app-shell{height:0;flex:1;min-height:0}
</style>
